export default __webpack_public_path__ + "static/media/options.f0932339.png";